/**
 * Why a podnět did not go out (F114, Pavel 2026-08-11).
 *
 * The form answered every refusal with one sentence, "Podnět se nepodařilo
 * odeslat.", which names nothing: not whose problem it is, not whether a
 * second click could help, and not that the typed text and the recording are
 * still sitting on the page. The server had already named the reason in the
 * body; the form threw it away (`if (!response.ok) throw new Error("submit")`).
 *
 * So each reachable refusal gets its own sentence under `beta.submitIssue`,
 * and everything else falls back to the shared client vocabulary. The overlay
 * exists because these sentences can say something the generic ones cannot:
 * nothing you wrote is lost.
 */

import { actionIssueLocaleKey, type ActionIssue } from "./action-error";

/**
 * The refusals `POST /api/feedback` can really produce. Anything outside this
 * set would be a sentence written for a situation this form cannot reach, so
 * it reads the shared vocabulary instead.
 *
 * `trial_not_ready` and `tester_before_transfer` are the two the server started
 * naming with F114; before that all three 409s arrived as one `state_conflict`.
 */
export const FEEDBACK_SUBMIT_ISSUES: readonly ActionIssue[] = [
  "trial_not_ready",
  "tester_before_transfer",
  // F134b: the instance changed hands. The one refusal on this form that is
  // not a timing problem - it says the conversation is over, and why.
  "ownership_transferred",
  "state_conflict",
  "forbidden",
  "not_found",
  "invalid_request",
  "rate_limited",
  "server",
  "offline",
  "generic"
];

const NAMED = new Set<ActionIssue>(FEEDBACK_SUBMIT_ISSUES);

export function feedbackSubmitIssueKey(issue: ActionIssue): string {
  return NAMED.has(issue) ? `beta.submitIssue.${issue}` : actionIssueLocaleKey(issue);
}
